export default __webpack_public_path__ + "static/media/lemonsito_1L.ab25fcf0.jpeg";